import { archiveDate } from "./triproutes-archive.mjs";
import { triproutesAgentLabel } from "./triproutes-history.mjs";

export const callStates = { settled: "Успешно", requested: "В работе", failed: "Ошибка", ambiguous: "Ответ не подтверждён" };
export const callTone = (call) => ({ settled:"ready", requested:"warning", failed:"error", ambiguous:"error" })[call.state] || "neutral";
const actionAgents={
  "triproutes-query-parse":"Разбор запроса", "triproutes-idea-suggest":"Дополнительные идеи", "triproutes-route-expand":"Создание маршрута",
  "triproutes-route-refinement-file":"Доработка маршрута", "triproutes-route-improvement":"Агент 7 · Улучшение маршрута",
  "triproutes-photo-location":"Поиск места по фотографии", "triproutes-route-content":"Текст маршрута", "triproutes-telegram-post":"Публикация для Telegram", "triproutes-route-corrector":"Агент 5.1 · Исправление маршрута",
};
export const callAgent = (call) => actionAgents[call.agent] || triproutesAgentLabel({ agentVersionRef:{ id:call.agent }, externalStageRef:call.stage });
export const callRunHash = (call) => `#/runs/${encodeURIComponent(call.runId)}?tab=usage&from=triproutes&list=metrics`;
export function callKnown(call) { return call.amount != null && Number.isFinite(Number(call.amount)) && Number(call.amount)>=0 && Boolean(call.currency) && ["final","reconciled","partial"].includes(call.costStatus); }
export function callMoney(call) {
  if (!callKnown(call)) return "Стоимость неизвестна";
  const n=Number(call.amount);
  const amount=n>0 && n<1e-9 ? call.amount.replace(".",",") : new Intl.NumberFormat("ru-RU",{minimumFractionDigits:2,maximumFractionDigits:n>0&&n<0.01?9:2}).format(n);
  return `${call.costStatus==="partial"?"Не менее ":""}${amount} ${call.currency}`;
}
export function callTokens(call,metric) {
  const names=metric==="cached_read_tokens"?[metric,"cached_input_tokens"]:[metric];
  return call.actualUsage?.find((m)=>names.includes(m.metric))?.quantity ?? null;
}
export function callCostReason(call) {
  const reason={network_timeout:"Таймаут сети",response_timeout:"Таймаут ответа",missing_usage:"Токены не сохранены",missing_tariff:"Нет тарифа",incomplete_tariff:"Тариф неполный",unclassified_usage:"Есть нераспознанные метрики",original_usage_not_saved:"Исходные токены не сохранены",settlement_pending:"Расчёт ещё не завершён"}[call.costReason];
  if(reason)return reason;
  if(callKnown(call)&&call.costStatus!=="partial")return "";
  if(call.actualUsage?.some((m)=>m.metric==="unclassified_paid_usage"&&m.quantity>0))return "Есть нераспознанные метрики";
  return call.actualUsage?.length?"Учтено частично":"Токены не сохранены";
}
export function callTooltip(call,timezone) {
  return `${callAgent(call)} · ${call.provider}: ${call.model} · ${archiveDate(call.requestedAt,timezone)}. ${callStates[call.state]||call.state}. ${callMoney(call)}${callCostReason(call)?`. ${callCostReason(call)}`:""}. Вход: ${callTokens(call,"input_tokens")??"нет данных"}; выход: ${callTokens(call,"output_tokens")??"нет данных"}.`;
}
export function callGeometry(calls,width) {
  // Physical calls have no city launch number. Their stable chronological order
  // uses timestamp labels and never invents domain or task numbers.
  if(!calls.length)return null;
  width=Math.max(720,width,calls.length*22+96);
  const height=320,plot={left:68,right:width-28,top:28,bottom:height-54};
  const amounts=calls.map(call=>callKnown(call)&&call.currency==="USD"?Number(call.amount):null);
  const max=Math.max(0.01,...amounts.filter(n=>n!==null));
  const spacing=(plot.right-plot.left)/Math.max(1,calls.length-1);
  const marks=calls.map((call,i)=>({call,x:plot.left+(calls.length===1?(plot.right-plot.left)/2:i*spacing),y:amounts[i]===null?null:plot.bottom-amounts[i]/max*(plot.bottom-plot.top)}));
  let path="",connected=false;
  for(const p of marks){if(p.y===null){connected=false;continue;}path+=`${connected?"L":"M"}${p.x},${p.y} `;connected=true;}
  const ticks=Array.from({length:5},(_,i)=>({value:max*i/4,y:plot.bottom-i/4*(plot.bottom-plot.top)}));
  return {marks,path,ticks,width,height,plot,labelStep:Math.max(1,Math.ceil(110/spacing))};
}
export function callQuery(filters,asOf="",cursor="",chart=false) {
  const q=new URLSearchParams({period:filters.period});
  for(const k of ["agent","model","site"])if(filters[k])q.set(k,filters[k]);
  if(asOf)q.set("asOf",asOf);if(cursor)q.set("cursor",cursor);if(chart)q.set("view","chart");
  return q;
}
